import React from "react";
import { CarouselModal } from "@src/lms/jelly/extensions/layouts/_lesson/case7/common/components/CarouselModal";
import { useIntl } from "react-intl";

import styles from "./MediaPlayer.module.scss";
import { useUi } from "@jelly/lesson";
import { messages } from "../../Preparations.messages";

type MediaPlayerModalProps = Omit<React.ComponentProps<typeof CarouselModal>, "children">;

export const MediaPlayerModal: React.FC<MediaPlayerModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <ui.Modal {...props}>
      <div className={styles.slide}>
        <div className={styles.content}>
          <h2 className={styles.title}>{formatMessage(messages.mediaPlayerModalTitle)}</h2>
          <p className={styles.description}>{formatMessage(messages.mediaPlayerModalDescription)}</p>
        </div>
      </div>
    </ui.Modal>
  );
};
